import React from 'react'
import { Copy } from '../../styles/typography';
import { MainButton } from '../../styles/buttons';
import { StepContainer } from '../../styles/reusables';

const Intro = ({ setStep }) => (
    <StepContainer>
        <Copy>
            Meet the WiPay x Shopify integration that gets your business online and accepting payments easily
        </Copy>
        <MainButton onClick={() => setStep(1)} whileHover={{scale: 1.01}}>Get Started</MainButton>
    </StepContainer>
)

export default Intro